export const handleImageError = ({ target }, src = '') => {
    const placeholderImage = '/assets/images/error/image-placeholder.png'

    target.onerror = null

    if (src !== '') {
        target.src = src
    } else target.src = placeholderImage
}
